import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function getUserPreferences(params) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret } = params;

    invariant(baseUrl, 'baseUrl is a required param of getUserPreferences()');
    invariant(brandId, 'brandId is a required param of getUserPreferences()');
    invariant(country, 'country is a required param of getUserPreferences()');
    invariant(uberToken, 'uberToken is a required param of getUserPreferences()');
    invariant(clientId, 'clientId is a required param of getUserPreferences()');

    const headers = { 'Content-Type': 'application/json' };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/person/@self/userpreferences`;

    return labelRequest(authenticatedRequest(new Request(url, { headers: new Headers(headers) }), uberToken, clientId, clientSecret), 'getUserPreferences');
}
